import { useEffect, useRef } from "react";
import { layers } from "./escape.mjs";

// One document listener for the whole app, bound the first time anything opens a
// layer. The rules (which layer, and never while typing) live in escape.mjs.
let bound = false;
function bind() {
  if (bound || typeof document === "undefined") return;
  bound = true;
  document.addEventListener("keydown", (e) => layers.handle(e));
}

/**
 * While `open`, Esc calls `onEscape`, unless something opened after it is still
 * open, in which case that closes first. Keyed on `open` alone, so a handler that
 * changes every render does not move the layer to the top of the stack.
 */
export default function useEscapeLayer(open, onEscape) {
  const handler = useRef(onEscape);
  handler.current = onEscape;
  useEffect(() => {
    if (!open) return undefined;
    bind();
    return layers.open(() => handler.current && handler.current());
  }, [open]);
}
